import {
  ProjectPayrollActionTypes,
  ProjectPayrollStateTypes,
} from "./ProjectPayroll.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: ProjectPayrollStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState(null),
};

const ProjectPayrollReducer = (
  state: ProjectPayrollStateTypes = INITIAL_STATE,
  action: any
): ProjectPayrollStateTypes => {
  switch (action.type) {
    case ProjectPayrollActionTypes.FETCH_ALL_PROJECT_PAYROLL:
      return {
        ...state,
        fetchAll: {
          ...state.fetchAll,
          isPending: true,
          isSuccessful: false,
          error: null,
        },
      };
    case ProjectPayrollActionTypes.FETCH_ALL_PROJECT_PAYROLL_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case ProjectPayrollActionTypes.FETCH_ALL_PROJECT_PAYROLL_SUCCESS:
      return {
        ...state,
        fetchAll: {
          ...state.fetchAll,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
          error: null,
        },
      };
    case ProjectPayrollActionTypes.FETCH_ALL_PROJECT_PAYROLL_FAILURE:
      return {
        ...state,
        fetchAll: {
          ...state.fetchAll,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };

    case ProjectPayrollActionTypes.FETCH_ONE_PROJECT_PAYROLL:
      return {
        ...state,
        fetchOne: {
          ...state.fetchOne,
          isPending: true,
          isSuccessful: false,
          error: null,
        },
      };
    case ProjectPayrollActionTypes.FETCH_ONE_PROJECT_PAYROLL_RESET:
      return {
        ...state,
        fetchOne: resetApiCallState(null),
      };
    case ProjectPayrollActionTypes.FETCH_ONE_PROJECT_PAYROLL_SUCCESS:
      return {
        ...state,
        fetchOne: {
          ...state.fetchOne,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
          error: null,
        },
      };
    case ProjectPayrollActionTypes.FETCH_ONE_PROJECT_PAYROLL_FAILURE:
      return {
        ...state,
        fetchOne: {
          ...state.fetchOne,
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };

    default:
      return state;
  }
};

export default ProjectPayrollReducer;
